// Configuration management with environment-specific settings and feature flags

const environments = {
  development: {
    SOLANA_NETWORK: 'devnet',
    SOLANA_RPC_URL: 'https://api.devnet.solana.com',
    PROGRAM_ID: '6eYBoAEeB5VXEfSGmkejDfTmmBxeqDyV5QWr19eF9Zst',
    API_BASE_URL: 'http://localhost:3001',
    ENABLE_DEBUG_LOGS: true,
    WALLET_AUTO_CONNECT: false,
  },
  staging: {
    SOLANA_NETWORK: 'devnet',
    SOLANA_RPC_URL: 'https://api.devnet.solana.com',
    PROGRAM_ID: '6eYBoAEeB5VXEfSGmkejDfTmmBxeqDyV5QWr19eF9Zst',
    API_BASE_URL: 'https://staging-api.znoospace.com',
    ENABLE_DEBUG_LOGS: false,
    WALLET_AUTO_CONNECT: true,
  },
  production: {
    SOLANA_NETWORK: 'mainnet-beta',
    SOLANA_RPC_URL: 'https://api.mainnet-beta.solana.com',
    PROGRAM_ID: 'PRODUCTION_PROGRAM_ID_HERE',
    API_BASE_URL: 'https://api.znoospace.com',
    ENABLE_DEBUG_LOGS: false,
    WALLET_AUTO_CONNECT: true,
  }
};

// Feature flags for gradual rollouts
const featureFlags = {
  ENABLE_NIGHTLY_WALLET: true,
  ENABLE_TOKEN_TIPPING: false,
  ENABLE_NFT_PROFILES: false,
  ENABLE_ADVANCED_ANALYTICS: false,
  ENABLE_AI_CURATION: false,
  ENABLE_PREDICTION_MARKETS: false,
  ENABLE_TIME_LOCKED_POSTS: false,
  ENABLE_COLLABORATIVE_POSTS: false,
  ENABLE_SOCIAL_TRADING: false,
  ENABLE_CROSS_CHAIN: false,
};

// Get current environment
const getCurrentEnvironment = () => {
  return process.env.NODE_ENV || 'development';
};

// Get configuration for current environment
const getConfig = () => {
  const env = getCurrentEnvironment();
  const config = environments[env] || environments.development;
  
  return {
    ...config,
    ENVIRONMENT: env,
    FEATURES: featureFlags,
  };
};

// Check if a feature is enabled
const isFeatureEnabled = (featureName) => {
  return featureFlags[featureName] || false;
};

// Update feature flag (for admin/testing purposes)
const setFeatureFlag = (featureName, enabled) => {
  if (featureFlags.hasOwnProperty(featureName)) {
    featureFlags[featureName] = enabled;
    console.log(`Feature ${featureName} ${enabled ? 'enabled' : 'disabled'}`);
  } else {
    console.warn(`Unknown feature flag: ${featureName}`);
  }
};

// Validate configuration
const validateConfig = () => {
  const config = getConfig();
  const required = ['SOLANA_NETWORK', 'SOLANA_RPC_URL', 'PROGRAM_ID'];
  
  for (const key of required) {
    if (!config[key]) {
      throw new Error(`Missing required configuration: ${key}`);
    }
  }
  
  return true;
};

export {
  getConfig,
  isFeatureEnabled,
  setFeatureFlag,
  validateConfig,
  getCurrentEnvironment,
};

export default getConfig();
